export default {"src":"/_next/static/media/karten.579b8d58.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};